import { useEffect } from 'react';

/**
 * Prevents Bootstrap body padding shift when modal is open
 * @param isOpen - Whether the modal is currently open
 */
export const usePreventBodyPaddingShift = (isOpen: boolean) => {
  useEffect(() => {
    if (isOpen) {
      // Prevent Bootstrap body padding shift
      document.body.style.paddingRight = '0px';
    }

    return () => {
      // Cleanup: restore padding in case other modals rely on it
      document.body.style.paddingRight = '';
    };
  }, [isOpen]);
};
